import type { DataTableColumn as GridColDef } from '@/components/custom/erp';
import { formatMoney } from '@/lib/formatUtils';

export const tableColumns: GridColDef[] = [
  {
    field: 'ma_kh',
    headerName: 'Mã khách hàng',
    width: 130
  },
  {
    field: 'ten_kh',
    headerName: 'Tên khách hàng',
    width: 250
  },

  {
    field: 'du_no',
    headerName: 'Dư nợ',
    width: 140,
    type: 'number',
    renderCell: (params: BanHangTableParams) => formatMoney(params.row.du_no)
  },
  {
    field: 'du_co',
    headerName: 'Dư có',
    width: 140,
    type: 'number',
    renderCell: (params: BanHangTableParams) => formatMoney(params.row.du_co)
  }
];
